<div class="flex justify-between items-center gap-4 w-full">
  <xemex-period-selector
    [options]="options()"
    [selected]="selected()"
    [framed]="framed()"
    (selectedChange)="selectedChange.emit($event)"
  >
  </xemex-period-selector>
  <xemex-time-selector
    [period]="selected()"
    [isTopological]="isTopological()"
    [isQuarterHour]="selected() === ChartRangeOptions.DayPerQuarter"
    [initialDate]="initialDate()"
    [framed]="framed()"
    (change)="change.emit($event)"
    (periodChange)="periodChange.emit($event)"
    (selectedDate)="selectedDate.emit($event)"
  >
  </xemex-time-selector>
</div>
